import React from "react";
import styles from "./LoadingSpinner.module.css";

const LoadingSpinner = () => {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.spinner}></div>
      <div className={styles.loadingText}>Loading Profile...</div>
    </div>
  );
};

export default LoadingSpinner;
